import axios from '@/lib/axios';
import { FixedAsset, Product } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2010. 固定資産登録
 * [POST] /workspaces/:identifier/fixed_assets
 */
type Props = {
  identifier: string;
  name: string;
  description: string;
  quantity: number;
  start_date: string;
  image_file: string;
  fixed_asset_status_id: number;
};
const createFixedAsset = (props: Props): Promise<FixedAsset> => {
  return axios.post(`/api/workspaces/${props.identifier}/fixed_assets`, props);
};

export const useCreateFixedAsset = () => {
  return useMutation({
    mutationFn: createFixedAsset,
  });
};
